import { traverseNode, isCommentNode } from 'anodum';
import {
  COMMENT_NODE_ATTRIBUTE_NAME,
  COMMENT_NODE_ATTRIBUTE_VALUE,
} from '../../constants/attributes';

const commentsToTemplates = (inputHTMLElement) => {
  const outputHTMLElement = inputHTMLElement.cloneNode(true);
  const commentNodes = [];

  traverseNode(outputHTMLElement, (node) => {
    if (isCommentNode(node)) {
      commentNodes.push(node);
    }
  });

  commentNodes.forEach((node) => {
    const { ownerDocument } = node;
    const template = ownerDocument.createElement('template');
    const targetNodeValue = node.nodeValue;

    template.setAttribute(COMMENT_NODE_ATTRIBUTE_NAME, COMMENT_NODE_ATTRIBUTE_VALUE);
    template.innerHTML = targetNodeValue;

    const fragment = commentsToTemplates(template.content);
    const tmp = ownerDocument.createElement('div');

    tmp.appendChild(fragment);
    template.innerHTML = tmp.innerHTML;
    node.replaceWith(template);
  });

  return outputHTMLElement;
};

export default commentsToTemplates;
